import { useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function ChatCallbackForm({ labels, language, path, sessionId, onSubmitted, onCancel }) {
  const [form, setForm] = useState({ name: '', phone: '', email: '' });
  const [state, setState] = useState('idle');
  const set = (k) => (e) => setForm(prev => ({ ...prev, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.email) return;
    setState('sending');
    try {
      const res = await fetch(`${API_URL}/api/callback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, language, source_page: 'chatbot', message: `Chat widget handoff (${path || 'unknown'}) — session ${sessionId}` })
      });
      if (!res.ok) throw new Error('callback failed');
      setState('done');
      onSubmitted();
    } catch {
      setState('error');
    }
  };

  if (state === 'done') return <div className="chatbot-msg chatbot-msg-bot" data-testid="chat-callback-success">{labels.cbSuccess}</div>;

  return (
    <form className="chat-callback-form" onSubmit={submit} data-testid="chat-callback-form">
      <strong>{labels.cbTitle}</strong>
      <input value={form.name} onChange={set('name')} placeholder={labels.cbName} required data-testid="chat-callback-name" />
      <input value={form.phone} onChange={set('phone')} placeholder={labels.cbPhone} type="tel" required data-testid="chat-callback-phone" />
      <input value={form.email} onChange={set('email')} placeholder={labels.cbEmail} type="email" required data-testid="chat-callback-email" />
      {state === 'error' && <span className="chat-callback-error" data-testid="chat-callback-error">{labels.cbError}</span>}
      <div className="chat-callback-actions">
        <button type="button" className="chat-callback-cancel" onClick={onCancel} data-testid="chat-callback-cancel">{labels.cbCancel}</button>
        <button type="submit" className="chat-callback-submit" disabled={state === 'sending'} data-testid="chat-callback-submit">
          {state === 'sending' ? labels.cbSending : labels.cbSend}
        </button>
      </div>
    </form>
  );
}
